import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reducers from './app/reducers';
import appComponent from './app/appComponent';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { BrowserRouter, Route } from 'react-router-dom';
import { composeWithDevTools } from 'redux-devtools-extension';
import { loadLogin } from './auth/localStorage';

let persistedState = loadLogin();

let store = createStore(reducers, persistedState, composeWithDevTools(applyMiddleware(thunk)));

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<Route path='/' component={appComponent} />
		</BrowserRouter>
	</Provider>,
	document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js